module.exports = __webpack_public_path__ + "img/JH.d771b5ab.png";